export default __webpack_public_path__ + "static/media/dash-talent.839e0b7c.svg";